import { render, staticRenderFns } from "./LargestFiles.vue?vue&type=template&id=54ae09ab&scoped=true&"
import script from "./LargestFiles.vue?vue&type=script&lang=js&"
export * from "./LargestFiles.vue?vue&type=script&lang=js&"
import style0 from "./LargestFiles.vue?vue&type=style&index=0&id=54ae09ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae09ab",
  null
  
)

export default component.exports